export function pathFromAWSUrl(awsUrl) {
    if (!awsUrl) {
      return ''
    }
    let url = new URL(awsUrl)
    let path = url.pathname // default assumption is that "url" is a cloudfront url, so the s3 key is just the path
  
    if (url.host === 's3.amazonaws.com') {
      const pathParts = url.pathname.split('/')
      pathParts.splice(1, 1) // this excludes the bucket name from the path to get the s3 key
      path = pathParts.join('/')
    }
    return decodeURIComponent(path.replace(/\+/g, ' ')) // imagekit expects unescaped characters in the path, and regular spaces instead of +'s
  }
  